<template>
<div class="page">
    <div class="loading-screen" v-if="status=='LOADING'">
        <div>
            <span class="spinner spinner--lg"></span>
            <span>loading submissions…</span>
        </div>
    </div>
    <div v-else>
        <ExaminerNavBar />
        <div class="container container--narrow">
            <div class="page-head rise">
                <h1>Submissions</h1>
                <p>Candidates who have submitted answers for this exam.</p>
            </div>

            <div v-if="users.length==0" class="glass empty-state rise">
                <div class="empty-state__icon">📭</div>
                <h2>No submissions yet</h2>
                <p>Answers will appear here as soon as candidates submit.</p>
                <a class="btn btn--ghost" href="/allassesments">← Back to exams</a>
            </div>

            <div v-else>
                <div v-for="(user, idx) in users" :key="user._id"
                     class="glass card card--hover mb-3 flex justify-between items-center rise" :class="`rise-${Math.min(idx+1,4)}`">
                    <div class="flex items-center gap-3">
                        <span class="brand__logo">{{(user.userId.name || '?').charAt(0).toUpperCase()}}</span>
                        <strong>{{user.userId.name}}</strong>
                    </div>
                    <a class="btn btn--primary btn--sm" :href="`/usersubmittions/${$router.history.current.params.id}/${user.userId._id}`">Review →</a>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import router from '../router';
import ExaminerNavBar from './ExaminerNavBar.vue';
import { getAllUserSubmition } from '@/services/answers';
export default {
    name: 'UserSubmittionsPage',
    data () {
        return {
            status: 'LOADING',
            users: []
        }
    },
    methods: {
        async getAllUserSubmition() {
            this.status='LOADING';
            try {
                const examId = router.history.current.params.id;
                const response = await getAllUserSubmition(examId);
                let flag =1;
                let users = response.data;
                for(let j in users) {
                    flag = 1;
                    for (let i in this.users) {
                        if(this.users[i].userId._id == users[j].userId._id)
                            flag = 0;
                    }
                    if (flag==1) {
                        this.users.push(users[j]);
                    }
                }

                this.status = "LOADED";
            }
            catch (error) {
                this.status = "ERROR";
                this.error = error.message;
            }
        },
    },
    created() {
        this.getAllUserSubmition();
    },
    components: {ExaminerNavBar}
}
</script>
